import React from 'react';
import { strCount } from '../../../helpers/stringutils';
import _filter from 'lodash/filter';
import ResponsiveImage from '../../shared/responsiveImage';
import { CYOA_NETWORK_IDS } from '../../../config'; 

const CyaoCard = (props) => {

  const cardData = _filter(props.citiesData, {'city': props.data.start_city})[0];
  const imageLink = (props.data.images === undefined && props.data.images[0].url === undefined) ? "" : props.data.images[0].url;
  const mapLink = (cardData === undefined) ? "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" : `https://api.mapbox.com/styles/v1/ken-busabout/cjm91nhzo0cji2rnyd5jx50g4/static/${cardData.long},${cardData.lat},6.0,0,0/140x140?access_token=${process.env.REACT_APP_MAPBOX_API_TOKEN}`;
  const destination = (props.cyoaId === CYOA_NETWORK_IDS["usa"].id) ? CYOA_NETWORK_IDS["usa"].name : CYOA_NETWORK_IDS["europe"].name;

  return (
    <div className={`columns small-12 medium-6 large-4 cyoa--card ${props.data.nr_trips > 0 ? 'has-product' : '' } ${props.cyoaId === CYOA_NETWORK_IDS["usa"].id  ? 'usa' : 'europe'}`}>
      <a href={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_PREVIEW_PAGE}?guid=${props.data.sequence_id}&style=${props.header.style.charAt(0)}&optionals=${props.header.optionals.charAt(0)}&city=${props.data.start_city}&currency=${props.currency.iso_currency_code}&stops=${props.data.nr_stops}&bundle=${props.data.nr_trips}&destination=${destination}`}>
        <div className="row">
          <div className="columns small-12">
            <div className="cyoa--card-image">
               <ResponsiveImage src={imageLink} width={300} widthRetina={600} alt={props.data.name} quality={60} />
               <div className="cyoa--card-map">
                  <img alt="map" src={`${mapLink}`} />
               </div>
            </div>

            <div className="cyoa--card-content">
              <div className="row">
                <div className="columns small-12">
                  <h3 className={`title ${strCount(props.data.name, 28, 'small')}`}>
                    {props.data.name} <span className="stop-text">{`${props.data.nr_stops} stops`}</span>
                    <small className={ `${props.cyoaId === CYOA_NETWORK_IDS["usa"].id ? 'hide' : '' }`}>
                      <svg className={`${ (props.data.nr_trips > 0) ? '' : 'hide' }`} width="12" height="12" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"/> </svg>
                      { props.data.sub_name }
                    </small>
                  </h3>
                </div>
              </div>
              <div className="row">
                 <div className="columns small-4">
                  <p className="subtitle"> {`${props.cyoaId === CYOA_NETWORK_IDS["usa"].id  ? 'Stops' : 'Countries'}`}</p>
                  <p>{props.cyoaId === CYOA_NETWORK_IDS["usa"].id ? props.data.nr_stops :  props.data.nr_countries}</p>
                </div>
                 <div className="columns small-4">
                  <p className="subtitle"> {`${props.cyoaId === CYOA_NETWORK_IDS["usa"].id  ? 'Destinations' : 'Cities'}`}</p>
                  <p>{props.data.nr_cities}</p>
                </div>
                <div className="columns small-4">
                  <p className="subtitle">Duration</p>
                  <p>{props.data.min_days} days</p>
                </div>
              </div>
              <div className="row">
                <div className="columns small-12">
                  <p className={`description no-margin ${strCount(props.data.cities, 128, 'small')}`}>{props.data.cities}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}

export default React.memo(CyaoCard);



// WEBPACK FOOTER //
// ./src/components/discover/components/cyao-card.js